import { IInfoTeamPlayers } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { GetMembersWithStatsParams } from '@grassrootly/api/gateways';

export const GetInfoTeamPlayers = async ({
  date_to,
  date_from,
  gid,
}: GetMembersWithStatsParams): Promise<IInfoTeamPlayers[]> => {
  const infoPlayers = withErrorCheck(
    // @ts-ignore
    await server.rpc("group_players_with_avg_ratings", { date_to, date_from, gid })
  );

  if (!infoPlayers) return [];

  return infoPlayers;
};
